module.exports = __webpack_public_path__ + "static/media/ReadWhite.64406654.svg";